// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import common from './assets/js/common'
import Vant, {
  Lazyload,
  Toast,
  Dialog,
} from 'vant';
import 'vant/lib/index.css';
import store from './assets/js/store'
import Cookies from 'js-cookie';

// 自定义组件
import headerTab from '@/components/headerTab';
import vueSearch from '@/components/search';
import recommendList from "@/components/recommendList";
Vue.config.productionTip = false

Vue.use(common)
Vue.use(Vant);
Vue.use(Lazyload, {});
Vue.prototype.Toast = Toast;
Vue.prototype.Dialog = Dialog;
Vue.prototype.Cookies = Cookies;
Vue.prototype.axios = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [function (data) {
    data = qs.stringify(data)
    return data
  }]
})

// tab切换
Vue.component('headerTab', headerTab)
// 搜索组件
Vue.component('vueSearch', vueSearch)
// 推荐模块
Vue.component("recommendList", recommendList);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js